import UsuariosComponent from '@/components/usuarios/UsuariosComponent'
import UsuariosFormComponent from '@/components/usuarios/UsuariosFormComponent'
import PerfilUsuarioComponent from '@/components/usuarios/PerfilUsuarioComponent'


export default [
{
    path: '/usuarios/',
    name: 'usuarios',
    component: UsuariosComponent,
    meta: {
        requiresAuth: true
    }
},{
    path: '/usuarios/nuevo',
    name: 'usuarios-nuevo',
    component: UsuariosFormComponent,
    meta: {
            requiresAuth: true
    }
},{
    path: '/usuarios/editar/:id/',
    name: 'usuarios-editar',
    component: UsuariosFormComponent,
    meta: {
            requiresAuth: true
    }
},{
    path: '/profile',
    name: 'profile',
    component: PerfilUsuarioComponent,
    meta: {
            requiresAuth: true
    }
},
]
